

    <div class="modal-detalle-backdrop">
        <section class="modal-actividad" role="dialog" aria-modal="true" aria-labelledby="tituloModalActividad"
            (click)="$event.stopPropagation()">
            <!-- ENCABEZADO -->
            <header class="modal-actividad__header">
                <div class="modal-actividad__icon">
                    <i class="icofont icofont-wrench"></i>
                </div>

                <div class="modal-actividad__heading">
                    <h4 id="tituloModalActividad">
                        {{ modoConsulta ? 'Detalle de actividad' : 'Gestionar actividad de mantenimiento' }}
                    </h4>

                    <p>
                        Orden {{ orden?.numero_orden || '—' }}
                        <span>·</span>
                        Vehículo {{ orden?.placa || '—' }}
                    </p>
                </div>

                <span class="estado-pill" [ngClass]="claseEstadoModal">
                    {{ estadoModal }}
                </span>

                <button type="button" class="modal-actividad__close" aria-label="Cerrar modal" (click)="cerrarModal()">
                    <i class="icofont icofont-close"></i>
                </button>
            </header>

            <form [formGroup]="formResultadoActividad">
                <div class="modal-actividad__body">

                    <!-- INFORMACIÓN DE LA ACTIVIDAD -->
                    <section class="form-section">
                        <div class="form-section__title">
                            <span class="section-number">
                                <i class="icofont icofont-info"></i>
                            </span>
                            <h5>Información de la actividad</h5>
                        </div>

                        <div class="actividad-info">
                            <div class="actividad-info__icon">
                                <i class="icofont icofont-wrench"></i>
                            </div>

                            <div class="actividad-info__main">
                                <small>Servicio / actividad</small>
                                <strong>{{ nombreActividad }}</strong>

                                <span>
                                    Sistema: {{ sistemaActividad || 'No especificado' }}
                                    <span class="separator">|</span>
                                    Tipo: {{ tipoMantenimientoNombre || 'No especificado' }}
                                </span>
                            </div>

                            <div class="actividad-info__detail">
                                <small>Estado actual</small>
                                <span class="estado-pill" [ngClass]="claseEstadoModal">
                                    {{ estadoModal }}
                                </span>
                            </div>

                            <div class="actividad-info__detail">
                                <small>Kilometraje programado</small>
                                <strong>
                                    {{ kilometrajeProgramado | number:'1.0-0' }} km
                                </strong>
                            </div>
                        </div>
                    </section>

                    <!-- RESULTADO -->
                    <section class="form-section">
                        <div class="form-section__title">
                            <span class="section-number">1</span>
                            <h5>Resultado de la actividad</h5>
                            <span class="required-mark">*</span>
                        </div>

                        <div class="resultado-grid">
                            <label class="resultado-option resultado-option--success"
                                [class.selected]="resultadoActual === 'REALIZADA'" [class.disabled]="modoConsulta">
                                <input type="radio" formControlName="resultado" value="REALIZADA" />

                                <i class="icofont icofont-check-circled"></i>

                                <span>
                                    <strong>Realizada</strong>
                                    <small>El trabajo se completó.</small>
                                </span>
                            </label>

                            <label class="resultado-option resultado-option--warning"
                                [class.selected]="resultadoActual === 'PARCIAL'" [class.disabled]="modoConsulta">
                                <input type="radio" formControlName="resultado" value="PARCIAL" />

                                <i class="icofont icofont-warning-alt"></i>

                                <span>
                                    <strong>Realizada parcialmente</strong>
                                    <small>Quedaron trabajos pendientes.</small>
                                </span>
                            </label>

                            <label class="resultado-option resultado-option--danger"
                                [class.selected]="resultadoActual === 'NO_REALIZADA'" [class.disabled]="modoConsulta">
                                <input type="radio" formControlName="resultado" value="NO_REALIZADA" />

                                <i class="icofont icofont-close-circled"></i>

                                <span>
                                    <strong>No realizada</strong>
                                    <small>Debe indicarse el motivo.</small>
                                </span>
                            </label>
                        </div>
                    </section>

                    <!-- EJECUCIÓN -->
                    <section class="form-section" *ngIf="resultadoActual !== 'NO_REALIZADA'">
                        <div class="form-section__title">
                            <span class="section-number">2</span>
                            <h5>Datos de ejecución</h5>
                        </div>

                        <div class="form-grid form-grid--four">
                            <div class="field">
                                <label>Fecha de realización <span>*</span></label>
                                <input type="date" class="form-control" formControlName="fecha_realizacion" />
                                <small class="field-error" *ngIf="campoInvalido('fecha_realizacion')">
                                    Selecciona una fecha válida.
                                </small>
                            </div>

                            <div class="field">
                                <label>Kilometraje de ejecución <span>*</span></label>

                                <div class="input-suffix">
                                    <input type="number" class="form-control" formControlName="kilometraje_ejecucion"
                                        min="0" step="1" placeholder="Ej. 105000" />
                                    <span>km</span>
                                </div>

                                <small class="field-error" *ngIf="campoInvalido('kilometraje_ejecucion')">
                                    Ingresa un kilometraje válido.
                                </small>
                            </div>

                            <div class="field">
                                <label>Tipo de mantenimiento</label>
                                <input class="form-control" [value]="tipoMantenimientoNombre" readonly />
                            </div>

                            <div class="field">
                                <label>Tipo de acción <span>*</span></label>
                                <ng-select #inputAccion [items]="tipoaccion" bindLabel="descripcion" formControlName="tipo_accion"
                                    bindValue="id" placeholder="Selecciona una opción">
                                </ng-select>
                            </div>

                            <div class="field field--span-2">
                                <label>Diagnóstico / resultado encontrado <span>*</span></label>
                                <textarea class="form-control" rows="3" formControlName="diagnostico"
                                    placeholder="Describe el estado encontrado..."></textarea>
                                <small class="field-error" *ngIf="campoInvalido('diagnostico')">
                                    El diagnóstico es obligatorio.
                                </small>
                            </div>

                            <div class="field field--span-2">
                                <label>Trabajo realizado <span>*</span></label>
                                <textarea class="form-control" rows="3" formControlName="trabajo_realizado"
                                    placeholder="Describe las labores ejecutadas..."></textarea>
                                <small class="field-error" *ngIf="campoInvalido('trabajo_realizado')">
                                    Describe el trabajo ejecutado.
                                </small>
                            </div>

                            <div class="field field--span-4" *ngIf="resultadoActual === 'PARCIAL'">
                                <label>Trabajo pendiente <span>*</span></label>
                                <textarea class="form-control" rows="2" formControlName="trabajo_pendiente"
                                    placeholder="Indica qué falta por realizar..."></textarea>
                            </div>
                        </div>
                    </section>

                    <!-- NO REALIZADA -->
                    <section class="form-section" *ngIf="resultadoActual === 'NO_REALIZADA'">
                        <div class="notice notice--warning">
                            <i class="icofont icofont-warning-alt"></i>
                            <div>
                                <strong>Actividad no ejecutada : </strong>
                                <p>
                                    Se conservará la novedad sin registrar un mantenimiento
                                    como realizado.
                                </p>
                            </div>
                        </div>

                        <div class="field mt-3">
                            <label>Motivo de no realización <span>*</span></label>
                            <textarea class="form-control" rows="3" formControlName="motivo_no_realizacion"
                                placeholder="Ej. falta de repuesto o autorización..."></textarea>
                        </div>
                    </section>

                    <!-- DATOS COMPLEMENTARIOS -->
                    <section class="form-section">
                        <div class="form-section__title">
                            <span class="section-number">3</span>
                            <h5>Datos complementarios</h5>
                        </div>

                        <div class="form-grid form-grid--four">
                            <div class="field field--span-2">
                                <label>Proveedor o Taller Mecánico:</label>
                            <div class="form-control p-0 border-0">
                                <ng-select #inputTaller placeholder="Selecciona una opción" formControlName="taller" [items]="empresaTaller"
                                    bindLabel="nombre" bindValue="nombre" class="js-example-placeholder-multiple">
                                </ng-select>
                            </div>
                            </div>

                            <div class="field field--span-2">
                                <label>Conductor / Responsable:</label>
                                <ng-select #inputConductor formControlName="conductor" [items]="conductor" bindValue="cedula" [bindLabel]="'cedula'"
                                    placeholder="Selecciona una opción" [searchFn]="customSearchFn" class="js-example-placeholder-multiple">
                                    <ng-template ng-label-tmp let-item="item">
                                        <span class="text-uppercase">
                                            {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                                            item.seapellidos }}
                                        </span>
                                    </ng-template>
                                
                                    <ng-template ng-option-tmp let-item="item">
                                        <span class="text-uppercase">
                                            {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                                            item.seapellidos }}
                                        </span>
                                    </ng-template>
                                </ng-select>
                            </div>

                            <div class="field field--span-2">
                                <label>Número de Factura:</label>
                                <input class="form-control" formControlName="factura"
                                    placeholder="Número del documento" />
                            </div>

                            <div class="field field--span-2">

                                <label>Forma de Pago:</label>
                               <ng-select #inputForma placeholder="Selecciona una opción"
                                formControlName="idFormaPago" 
                                [items]="formapago"
                                bindLabel="descripcion" 
                                bindValue="id">
                                </ng-select>
                             
                            </div>

                            <div class="field field--span-2">
                                <label>Valor Pagado (COP):</label>
                                <input class="form-control" type="number" min="0" formControlName="valor_pagado"
                                    placeholder="0" />
                            </div>

                            <div class="field field--span-2">
                                <label>¿Requiere Seguimiento? <span>*</span></label>
                                <select class="form-select" formControlName="requiere_seguimiento">
                                    <option [ngValue]="false">No</option>
                                    <option [ngValue]="true">Sí</option>
                                </select>
                            </div>

                            <div class="field field--span-4"
                                *ngIf="formResultadoActividad.get('requiere_seguimiento')?.value">
                                <label>Descripción del Seguimiento <span>*</span></label>
                                <textarea class="form-control" rows="2"
                                    formControlName="descripcion_seguimiento"></textarea>
                            </div>

                            <div class="field field--span-4">
                                <label>Observaciones:</label>
                                <textarea class="form-control" rows="2" formControlName="observaciones"
                                    placeholder="Novedades adicionales..."></textarea>
                            </div>
                        </div>
                    </section>

                    <!-- SOPORTES -->
                    <section class="form-section">
                        <div class="form-section__title">
                            <span class="section-number">4</span>
                            <h5>Soportes y evidencias</h5>
                        </div>

                        <div class="upload-grid">
                            <div class="upload-card">
                                <div class="upload-card__heading">
                                    <i class="icofont icofont-file-pdf"></i>
                                    <div>
                                        <strong>Soporte de factura</strong>
                                        <small>PDF, JPG o PNG · Máximo 10 MB</small>
                                    </div>
                                </div>

                                <label class="upload-zone" [class.upload-zone--disabled]="modoConsulta">
                                    <i class="icofont icofont-upload-alt"></i>
                                    <span>
                                        {{ archivoFactura?.name || 'Seleccionar factura' }}
                                    </span>
                                    <small>Haz clic para buscar el archivo</small>

                                    <input type="file" accept=".pdf,image/jpeg,image/png" [disabled]="modoConsulta"
                                        (change)="seleccionarFactura($event)" />
                                </label>
                            </div>

                            <div class="upload-card">
                                <div class="upload-card__heading">
                                    <i class="icofont icofont-image"></i>
                                    <div>
                                        <strong>Soporte del mantenimiento</strong>
                                        <small>Fotografías del trabajo ejecutado</small>
                                    </div>
                                </div>

                                <label class="upload-zone" [class.upload-zone--disabled]="modoConsulta">
                                    <i class="icofont icofont-camera"></i>
                                    <span>Agregar evidencias</span>
                                    <small>JPG, PNG o WEBP · Máximo 10 MB por archivo</small>

                                    <input type="file" accept="image/jpeg,image/png,image/webp" multiple
                                        [disabled]="modoConsulta" (change)="seleccionarEvidencias($event)" />
                                </label>

                                
                            </div>
                        </div>
                        <div class="file-list" *ngFor="let archivo of evidenciasSeleccionadas; let i = index">
                                    <i class="icofont icofont-image"></i>
                                    <span>{{ archivo.name }}</span>
                                    <button type="button" [disabled]="modoConsulta" (click)="eliminarEvidencia(i)">
                                        <i class="icofont icofont-trash"></i>
                                    </button>
                                </div>
                    </section>

                    <div class="notice notice--info">
                        <i class="icofont icofont-info-circle"></i>
                        <p>
                            La fecha oficial de registro y el usuario se validan en el servidor.
                            La factura es el soporte económico y no finaliza automáticamente
                            otras actividades de la orden.
                        </p>
                    </div>
                </div>

                <!-- PIE -->
                <footer class="modal-actividad__footer">
                    <button type="button" class="btn btn-secondary" (click)="cerrarModal()">
                        Cancelar
                    </button>

                    <button *ngIf="!modoConsulta" type="button" class="btn-guardar" [disabled]="guardandoActividad" (click)="guardarResultadoActividad()"   >
                        <span *ngIf="guardandoActividad" class="spinner-border spinner-border-sm"></span>

                        <i *ngIf="!guardandoActividad" class="icofont icofont-save"></i>

                        {{ guardandoActividad ? 'Guardando...' : 'Guardar' }}
                    </button>
                </footer>
            </form>
        </section>
    </div>
